import { SpectrumColor } from '../types';

export const Red: SpectrumColor = {
  0: '#FFFAFA',
  5: '#FFF5F5',
  10: '#FFEBEB',
  15: '#FFE1E1',
  20: '#FFD6D6',
  25: '#FFC5C5',
  30: '#FFB3B3',
  35: '#FE9A9A',
  40: '#FD8181',
  50: '#FB6767',
  60: '#FC4040',
  70: '#E52C2C',
  80: '#C51414',
  90: '#A00D0D',
  100: '#7D0808',
  110: '#570000',
  default: 80,
};
